import './VideoList.scss';

export default function EmptyList() {
  return (
    <div className="video-list--empty">
      <p>No videos found.</p>
    </div>
  );
}
